import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/contract_types/`, data);
};

const getAll = async () => {
  return await httpClient.get(`/contract_types/`);
};

const get = async (id) => {
  return await httpClient.get(`/contract_types/${id}`);
};

const put = async (id, data) => {
  return await httpClient.put(`/contract_types/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`/contract_types/${id}`);
};

const filter = async (query) => {
  return await httpClient.get(`/contract_types/?${query}`);
};

export { post, getAll, get, put, remove, filter };
